import { Buffer } from 'buffer';

export function decodeBarcode(barcode?: string | null): string {
  if (!barcode) return '';

  try {
    const buffer = Buffer.from(`${barcode}`, 'base64');
    return buffer.toString('base64') === barcode ? buffer.toString('utf8') : barcode;
  } catch {
    return barcode;
  }
}
